(function () {
  const menuToggle = document.querySelector(".menu-toggle");

  function closeMenu() {
    document.body.classList.remove("nav-open");
    menuToggle?.setAttribute("aria-expanded", "false");
  }

  menuToggle?.addEventListener("click", () => {
    const isOpen = document.body.classList.toggle("nav-open");
    menuToggle.setAttribute("aria-expanded", String(isOpen));
  });

  document.querySelectorAll(".site-nav a, .header-actions a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

})();
